import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT, CHANNEL_HEADER } from '../../APIConstants';
import { setAGraphHeaders } from '../../utils';

import { AGraphApiSettings } from '../Base';
import { AW_PORTFOLIO_ANALYSIS_REPORTS_API_URL } from './Constants';

interface Settings extends AGraphApiSettings {
  getConfigurationDirectoryFn?: () => string | undefined;
}

export const awPortfolioAnalysisReportApiClient = axios.create();

export const awPortfolioAnalysisReportSettings: Settings = {
  getAladdinApiKey: undefined,
  getConfigurationDirectoryFn: undefined,
  getEnvTypeFn: undefined,
};

awPortfolioAnalysisReportApiClient.interceptors.request.use((config) => {
  const { getConfigurationDirectoryFn, getAladdinApiKey, getEnvTypeFn } = awPortfolioAnalysisReportSettings;

  const baseURL = AW_PORTFOLIO_ANALYSIS_REPORTS_API_URL;
  const configurationDirectory = getConfigurationDirectoryFn?.();

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: API_TIMEOUT,
    params: {
      ...config.params,
      configurationDirectory,
    },
  };

  // See SMART_FILTER_API_CONFIG for more details
  const hasCustomChannelHeader = config.headers?.[CHANNEL_HEADER];

  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), getEnvTypeFn?.());

  if (hasCustomChannelHeader) {
    updatedConfig.headers[CHANNEL_HEADER] = hasCustomChannelHeader;
  }

  return updatedConfig;
});
